import React, { FC } from 'react';
import { Box, BoxProps } from '@material-ui/core';

interface Props extends BoxProps {
  label: string;
}

export const TabBadge: FC<Props> = ({ label, ...props }) => {
  return (
    <Box paddingX='10px' paddingTop='1px' borderRadius='10px' bgcolor='#f1f1f1' color='#828282' {...props}>
      {label}
    </Box>
  );
};
